export interface ExperimentChecker {
  isExperimentalFeatureEnabled?: (feature: string) => boolean;
  isPlatformFeatureEnabled?: (feature: string) => boolean;
}

export const checkExperimentBase = (
  context: ExperimentChecker,
  feature: string
) => {
  return (
    context.isExperimentalFeatureEnabled &&
    context.isExperimentalFeatureEnabled(feature)
  );
};
